import React from 'react';


function Position() {
  return (
    <div>
          <section className='position-section'>
    <div className='wrapper'>
    <div className='title'>Положение о проведении Международного конкурса "Звезды красоты"</div>
    </div>
    </section>
    <section className='main-section'>
          <div className='wrapper'>
    <div className='position-cont'>
    <div className='position-title'>1. Общие положения</div>
    <div className='position-text '>1.1. Конкурс "Звезды красоты" организован с целью выявления, поддержки и развития талантов в индустрии красоты на международном уровне.</div>
    <div className='position-text'>1.2. Конкурс проводится среди профессионалов, имеющих опыт работы в сфере красоты не менее трех лет.</div>
    <div className='position-text'>1.3. Участие в конкурсе является почетным и подтверждает высокий профессиональный уровень участников и судей.</div>
    <div className='position-text'>1.4. Прием заявок на конкурс проводится ежегодно с 1 по 31 января.</div>
    <div className='position-text'>1.5. Ежегодное подведение итогов конкурса 1 февраля.</div>
    </div>
    <div className='position-cont'>
    <div className='position-title'>2. Условия участия</div>
    <div className='position-text'>2.1. Для участия в конкурсе необходимо подать заявку через официальный сайт конкурса, заполнив все требуемые поля и приложив портфолио своих работ. </div>
    <div className='position-text'>2.2. Участники должны соответствовать критериям, установленным в каждой конкурсной номинации. </div>
    <div className='position-text'>2.3. Регистрационный взнос за участие в конкурсе устанавливается организаторами и может различаться в зависимости от номинации.</div>
    </div>
    <div className='position-cont'>
    <div className='position-title'>3. Номинации</div>
    <ul className="custom-list">
      <li>Маникюр, моделирование, дизайн, педикюр и подология</li>
      <li>Перманентный макияж, а также Lash и Brow направление</li>
      <li>Парикмахерское искусство</li>
      <li>Инновации в косметологии</li>
      <li>Массаж и телесные терапии</li>
      <li>Искусство Визажа</li>
      <li>Мастерство в области стиля и имиджа</li>
      <li>Фотография и видеография в индустрии красоты</li>
        </ul>
    </div>
    <div className='position-cont'>
    <div className='position-title'>4. Критерии оценки</div>
    <div className='position-text'>4.1. Работы оцениваются по следующим критериям: техническое мастерство, инновационность, креативность, соблюдение профессиональных стандартов, и эстетическая привлекательность работ.</div>
    <div className='position-text'>4.2. Оценка проводится судейским комитетом, состоящим из ведущих специалистов индустрии.</div>
    </div>
    <div className='position-cont'>
    <div className='position-title'>5. Судейский комитет</div>
    <div className='position-text'>5.1. Судьи выбираются организаторами конкурса на основании их профессионального опыта и вклада в индустрию красоты не менее трех лет. </div>
    <div className='position-text'>5.2. Судьи обязаны проводить оценку работ объективно и беспристрастно.</div>
    </div>
    <div className='position-cont'>
    <div className='position-title'>6. Награды и призы</div>
    <div className='position-text'>6.1. Победители в каждой номинации получают дипломы, трофеи и ценные призы от спонсоров конкурса. </div>
    <div className='position-text'>6.2. Все участники получают сертификаты участия.</div>
    </div>
    <div className='position-cont'>
    <div className='position-title'>7. Финальные положения</div>
    <div className='position-text'>7.1. Организаторы оставляют за собой право изменения условий конкурса. Все изменения и дополнения будут заблаговременно опубликованы на официальном сайте конкурса.</div>
    <div className='position-text'>7.2. Решения судейской комиссии являются окончательными и не подлежат обжалованию.</div>
    </div>
    </div>
    </section>
    </div>
  );
}

export default Position;
